export const availability = "availability";
export const rate = "rate";
export const date = "date";
export const pharmacy = "pharmacy";
export const distance = "distance";
export const maxDistanceValue = 300;
